export const PACKAGE_VERSION = import.meta.env.PACKAGE_VERSION;

export const IS_DEV = import.meta.env.DEV;
export const IS_PROD = import.meta.env.PROD;

export const POSTHOG_HOST = "https://ph.wayflyer.com";
